import { type PaginationParams } from '@webapp/core/providers/Pagination/pagination.types'
import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { auditLogRepository } from '../data-access/repositories'

const base = ['audit-log']

export const auditLogQueryConfig = {
  getAuditLog: (params?: {
    contentTypeId?: number
    objectId?: string
    paginationParams?: PaginationParams
  }) => {
    const { contentTypeId, objectId, paginationParams } = params || {}

    return {
      // `objectId ?? null`: buildQueryKey truncates at the FIRST undefined,
      // so a raw undefined objectId would drop paginationParams from the
      // module-wide key and page changes would never refetch (BHV-030).
      // null passes through; the invalidation prefix
      // ['audit-log', contentTypeId] stays stable for both shapes.
      queryKey: buildQueryKey([
        ...base,
        contentTypeId,
        objectId ?? null,
        paginationParams,
      ]),
      queryFn: () => {
        if (contentTypeId === undefined) {
          throw new Error(
            'Missing required parameters for getAuditLog query. Ensure contentTypeId is defined.'
          )
        }

        return auditLogRepository.getAuditLog(
          contentTypeId,
          objectId,
          paginationParams
        )
      },
    }
  },
}
